import replyid from "../../api/replyid";
import { perPageCount } from "@/common/constants";
import { dummyRows } from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      perPageCount: perPageCount,
    },
    totalItems: 0,
  };
};

// initial state
const state = getDefaultState();
// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    return state.items;
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.perPageCount !== params.perPageCount
    ) {
      commit("setLoaded", false);
      commit("setFilter", { ...params });
      replyid.fetchItems(params, (data) => {
        commit("setItems", { items: data.items });
        commit("setLoaded", true);
        commit("setTotalItems", data.total);
      });
    }
  },

  resetItems({ commit, state, dispatch }) {
    commit("setItems", { items: [] });
    commit("setTotalItems", 0);
    dispatch("refreshItems", state.filter);
  },

  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },

  deleteReplyId({ dispatch }, id) {
    return replyid.delete(id).then(function () {
      dispatch("refreshItems");
    });
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

// mutations
const mutations = {
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
